// src/components/intake/IntakeWorkLocation.js
//
// Ticket 064 (D8, amendment 1). The intake-only "Where did you do this work?"
// question for ONE employment card (yours or your spouse's). It is rendered
// INSIDE the card through IncomeCard's optional `renderItemExtra` slot. Options
// come from EMPLOYMENT_WORK_LOCATION_OPTIONS. Required for each filled-in
// employment card. The answer is kept next to the card by its id, not on it.

import React from 'react'
import { Select } from '../../pages/CalculatorFields'
import {
  EMPLOYMENT_WORK_LOCATION_OPTIONS,
  WORK_LOCATION_QUESTION,
  WORK_LOCATION_QUESTION_SPOUSE,
  WORK_LOCATION_HINT,
} from '../../lib/intake/intakeConfig'

export default function IntakeWorkLocation({ item, owner, value, onChange }) {
  return (
    <div className="intake-worklocation">
      <div className="u-form-label">{owner === 'spouse' ? WORK_LOCATION_QUESTION_SPOUSE : WORK_LOCATION_QUESTION}</div>
      <p className="u-hint">{WORK_LOCATION_HINT}</p>
      <Select
        value={value || ''}
        onChange={(v) => onChange(item.id, v)}
        options={EMPLOYMENT_WORK_LOCATION_OPTIONS}
        placeholder="Choose an option…"
      />
    </div>
  )
}
